import React from "react";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";

const WizardPopupEditGroupViewType = () => {

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {viewType} = wizardPopupState;

  const viewButtonClick = () => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        viewType: viewType === 4 ? 1 : viewType + 1
      }
    })
  }

  return (
    <button className={"wizard-popup__viewType ui-button--view-type ui-button--view-type--" + viewType}
            onClick={viewButtonClick}>
      {viewType === 1 ? <span/> : null}
      {viewType === 2 ? (
        <p><span/><span/><span/><span/><span/><span/></p>
      ) : null}
      {viewType === 3 ? (
        <p><span/><span/><span/><span/><span/><span/><span/><span/><span/></p>
      ) : null}
      {viewType === 4 ? (
        <p><span/><span/><span/></p>
      ) : null}
    </button>
  )
};

export default WizardPopupEditGroupViewType
